import Vue from 'vue';
import ChunkLoadError from '@/plugins/chunk-load-error';
import App from './App.vue';
import { createRouter } from './router';
import { installGuards } from './guards';
import SATracking, { SATrackingPlugin } from '@/shared/saTracking';

import { Toast, Dialog } from 'vant';
import createPinia from '@/stores';
import mergeSetup from './mergeSetup';
import NavBar from '@/x-components/nav-bar';
import Popup from '@/x-components/popup';

import 'vant/es/toast/style/less';
import 'vant/es/notify/style/less';
import '~/vant-extra/style-override/notify.css';
import 'vant/es/dialog/style/less';
import '~/vant-extra/style-override/dialog.css';
import 'vant/es/lazyload/style/less';

import '@/styles/vars.css';
import '@/styles/reset.css';
import '@/styles/base.css';

// 临时方案，Vue 2.7/3.x 中setup在mixin中不会被合并，此方案目前主要用于mixin向setup过渡时的兼容性保证。
// 当所有mixin改为setup实现后，此处应该被删除
Vue.config.optionMergeStrategies.setup = mergeSetup;

Vue.use(NavBar);
Vue.use(Popup);

const router = createRouter();
const pinia = createPinia();

/**
 * 神策埋点初始化
 */
if (process.env.NODE_ENV === 'production' || process.env.VUE_APP_SADATA_DEBUG === 'true') {
  let projectName = 'yxhzs';
  let showLog = false;

  if (process.env.VUE_APP_RUNTIME_ENV !== 'prod') {
    projectName = 'yxhcs';
    showLog = true;
  }

  SATracking.init({
    projectName,
    showLog,
  });
}

Vue.use(ChunkLoadError, { router });
Vue.use(SATrackingPlugin);

/**
 * 设置所有toast的默认参数
 */
Toast.setDefaultOptions({ duration: 3000 });

/**
 * 设置所有dialog的默认参数
 */
Dialog.setDefaultOptions({
  closeOnPopstate: false,
});

/**
 * 暴露全局router提供给axios使用
 */
window.__g_router__ = router;

/**
 * 安装路由导航守卫/拦截器
 */
installGuards(router, pinia);

/**
 * 暴露全局app
 */
window.__g_app__ = new Vue({
  router,
  pinia,
  data() {
    return {
      isRouterAlive: true,
    };
  },
  render(h) {
    if (this.isRouterAlive) {
      return h(App);
    }

    return h();
  },
  methods: {
    /**
     * 强制刷新当前页面
     */
    forceReload() {
      this.isRouterAlive = false;
      this.$nextTick(() => {
        this.isRouterAlive = true;
      });
    },
  },
}).$mount('#app');
